export default __webpack_public_path__ + "static/media/logo.26ae7975.png";